import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { useColors, ThemeColors } from '../../hooks/useColors';

interface ChipProps {
  label: string;
  onRemove?: () => void;
  onPress?: () => void;
  selected?: boolean;
}

export function Chip({ label, onRemove, onPress, selected }: ChipProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  return (
    <TouchableOpacity 
      style={[
        styles.chip,
        selected && styles.selected,
        onPress && styles.pressable
      ]} 
      onPress={onPress}
      disabled={!onPress}
    >
      <Text style={[styles.label, selected && styles.selectedLabel]}>
        {label}
      </Text>
      {onRemove && (
        <TouchableOpacity 
          onPress={onRemove}
          hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
        >
          <Feather 
            name="x" 
            size={16} 
            color={selected ? colors.surface : colors.textLight} 
          />
        </TouchableOpacity>
      )}
    </TouchableOpacity>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.backgroundSecondary,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 9999,
    gap: 6,
  },
  selected: {
    backgroundColor: colors.success,
  },
  pressable: {
    opacity: 0.8,
  },
  label: {
    fontSize: 14,
    color: colors.textLight,
  },
  selectedLabel: {
    color: colors.surface,
  },
}); 